module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.getters['player/isPlaying']) ? _c('div', {
    staticClass: "side-player"
  }, [_c('v-dialog', {
    model: {
      value: (_vm.showListeningMessage),
      callback: function($$v) {
        _vm.showListeningMessage = $$v
      },
      expression: "showListeningMessage"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Still Listening")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you still Listening?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideListeningMessage($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "side-player-inner"
  }, [_c('div', {
    staticClass: "track-detail-section"
  }, [_c('div', {
    staticClass: "track-cover-container",
    style: ({
      width: _vm.isMini ? '100%' : ''
    })
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.item.album_type) + "/" + (_vm.item.slug))
    }
  }, [(_vm.item.album_type == 'playlist') ? [_c('div', {
    staticClass: "track-cover-image",
    class: _vm.item.album_type,
    style: ({
      'background-image': ("url(" + _vm.album1Cover + "), url(" + _vm.album2Cover + "), url(" + _vm.album3Cover + "), url(" + _vm.album4Cover + ")"),
    })
  }, [_c('div', {
    staticStyle: {
      "max-width": "180px",
      "padding-top": "10.5rem",
      "padding-left": "10px"
    }
  }, [_c('label', {
    staticClass: "ellipsisIt cursor-pointer",
    staticStyle: {
      "background-color": "black"
    }
  }, [_vm._v(_vm._s(_vm.track.name))]), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('router-link', {
    staticClass: "user-name cursor-pointer",
    staticStyle: {
      "background-color": "black"
    },
    attrs: {
      "to": '/' + _vm.item.user.slug
    }
  }, [_vm._v(_vm._s(_vm.item.user.username) + "???")])], 1)])])] : [_c('div', {
    staticClass: "track-cover-image",
    style: ({
      'background-image': 'url(' + _vm.item.cover.url + ')'
    })
  })]], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "track-info-container"
  }, [_c('div', {
    staticClass: "track-info"
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center"
  }, [(!_vm.isMini) ? _c('div', {
    staticClass: "follow-meta"
  }, [_c('div', {
    staticClass: "dflex align-center justify-space-between width100"
  }, [_c('div', {
    staticClass: "actions-section flex-none",
    class: {
      _mini: _vm.isMini
    }
  }, [_c('v-menu', {
    staticClass: "dots-wrapper",
    attrs: {
      "offset-y": "",
      "dark": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "slot": "activator",
      "right": ""
    },
    slot: "activator"
  }, [_vm._v("more_horiz")]), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "depressed": "",
      "color": "transparent ma-0"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showShareModal = true;
        _vm.modalMode = true;
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_share.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Share")])], 1)], 1), _vm._v(" "), (_vm.stripeConnected) ? _c('v-list-tile', [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "depressed": "",
      "color": "transparent ma-0"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDownloadModal = true;
        _vm.modalMode = true;
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_download.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Download")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "depressed": "",
      "color": "transparent ma-0"
    },
    nativeOn: {
      "click": function($event) {
        _vm.repostItem()
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_repost.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Repost")])], 1)], 1)], 1)], 1)], 1)])]) : _vm._e()])])])])]), _vm._v(" "), (!_vm.isMini) ? _c('div', {
    staticClass: "player-section-container",
    class: {
      'd-block': _vm.isLoaded,
      'dflex': !_vm.isLoaded
    }
  }, [(!_vm.isLoaded) ? _c('div', {
    staticClass: "loading flex-none",
    attrs: {
      "id": "loading"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoaded) ? _c('div', {
    staticClass: "player-section"
  }, [_c('div', {
    staticClass: "controls-section"
  }, [_c('v-btn', {
    staticClass: "player-control-btn no-Btn-bg _prev",
    attrs: {
      "ripple": false,
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.skip('prev')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_rewind.svg",
      "width": "20"
    }
  })]), _vm._v(" "), (!_vm.isPlaying) ? _c('v-btn', {
    staticClass: "player-control-btn play no-Btn-bg _play",
    attrs: {
      "ripple": false,
      "flat": "",
      "id": "play"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$root.$emit(_vm.MyEvents.AUDIO_PLAYER_REPLAY)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_play.svg",
      "height": "26"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isPlaying) ? _c('v-btn', {
    staticClass: "player-control-btn pause no-Btn-bg _pause",
    attrs: {
      "ripple": false,
      "flat": "",
      "id": "pause"
    },
    nativeOn: {
      "click": function($event) {
        _vm.pause()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_pause.svg",
      "height": "26"
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "player-control-btn no-Btn-bg _next",
    attrs: {
      "ripple": false,
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.skip('next')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_skip.svg",
      "width": "20"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "bar-section"
  }, [_c('label', {
    staticClass: "duration-time played",
    attrs: {
      "id": "playedTime"
    }
  }, [_vm._v(_vm._s(_vm.playedTime))]), _vm._v(" "), _c('v-spacer', [_c('v-slider', {
    staticClass: "player-bar",
    attrs: {
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.seek(_vm.progress)
      }
    },
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "duration-time total",
    attrs: {
      "id": "totalTime"
    }
  }, [_vm._v(_vm._s(_vm.totalTime))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showReminder) ? _c('div', {
    staticClass: "reminder-section"
  }, [_vm._m(0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.modalMode),
      callback: function($$v) {
        _vm.modalMode = $$v
      },
      expression: "modalMode"
    }
  }, [(_vm.showShareModal) ? _c('share-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.dismissShareDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showDownloadModal) ? _c('download-modal', {
    attrs: {
      "item": _vm.item,
      "track": _vm.track,
      "dismiss": _vm.dismissDownloadDialog
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_auto dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard1),
      callback: function($$v) {
        _vm.show_modalCard1 = $$v
      },
      expression: "show_modalCard1"
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../assets/nav_logo_white.png"),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(" " + _vm._s(this.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/check-white.svg"),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n              Create account\n            ")])])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_auto dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard2),
      callback: function($$v) {
        _vm.show_modalCard2 = $$v
      },
      expression: "show_modalCard2"
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../assets/nav_logo_white.png"),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: (("background-image: url(" + _vm.bgDemoImg + ")"))
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(" " + _vm._s(this.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/check-white.svg"),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-center font-inter"
  }, [_c('p', [_vm._v("Get full access. "), _c('b', [_vm._v("50%")]), _vm._v(" of your subscription is shared with creators you stream most. See who you support!")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\tStart 30 day free trial\n\t\t\t\t\t\t")])])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_50 dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard3),
      callback: function($$v) {
        _vm.show_modalCard3 = $$v
      },
      expression: "show_modalCard3"
    }
  }, [_c('div', {
    staticClass: "modal-card-main"
  }, [_c('div', {
    staticClass: "modal-card-split"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../assets/nav_logo_white.png"),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(_vm._s(this.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/check-white.svg"),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n                Create account\n              ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-title-img",
    style: (("background-image: url(" + _vm.videoLoading + ")"))
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [(_vm.spotlightVideoSource) ? _c('source', {
    attrs: {
      "src": ("https://stream.mux.com/" + _vm.spotlightVideoSource + "/low.mp4"),
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/mute-icon.svg"),
      "width": "17px"
    }
  })])])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_50 dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard4),
      callback: function($$v) {
        _vm.show_modalCard4 = $$v
      },
      expression: "show_modalCard4"
    }
  }, [_c('div', {
    staticClass: "modal-card-main"
  }, [_c('div', {
    staticClass: "modal-card-split"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../assets/nav_logo_white.png"),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(_vm._s(this.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/check-white.svg"),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "font-inter"
  }, [_c('p', [_vm._v("Get full access. "), _c('b', [_vm._v("50%")]), _vm._v(" of your subscription is shared with creators you stream most. See who you support!")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tStart 30 day free trial\n\t\t\t\t\t\t\t")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-title-img",
    style: (("background-image: url(" + _vm.videoLoading + ")"))
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [(_vm.spotlightVideoSource) ? _c('source', {
    attrs: {
      "src": ("https://stream.mux.com/" + _vm.spotlightVideoSource + "/low.mp4"),
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/mute-icon.svg"),
      "width": "17px"
    }
  })])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media d-flex"
  }, [_c('div', {
    staticClass: "media__image"
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v("Reminder!")]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n              Support your favorite artists & brands\n            ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13981b31","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sideAudioPlayer.vue
// module id = 1615
// module chunks = 180